import { Pipe, PipeTransform } from "@angular/core";
import { RequestType } from "@handshake/core-types";

@Pipe({
  name: "requestType",
})
export class RequestTypePipe implements PipeTransform {
  transform(requestType: RequestType): string {
    switch (requestType) {
      case RequestType.MILESTONE_COMPLETED:
        return "Milestone Completed";
      case RequestType.DELAY:
        return "Delayed";
      case RequestType.DRAWDOWN:
        return "Drawdown";
      default:
        return "";
    }
  }
}
